import { type Control, Controller, type ControllerProps, type FieldPath, type FieldValues } from 'react-hook-form';
import { type SlotProps, TextField } from '@mui/material';

type CProps = Omit<ControllerProps<FieldValues, FieldPath<FieldValues>, FieldValues>, 'render'>;

interface FormTextProps extends CProps {
  control: Control<any>;
  label: React.ReactNode;
  trim?: boolean;
  number?: boolean;
  slotProps?: SlotProps<React.ElementType, unknown, unknown>;
  type?: React.InputHTMLAttributes<unknown>['type'];
}

export const FormText: React.FC<FormTextProps> = ({ trim, number, label, type, slotProps, ...rest }) => {
  return (
    <Controller
      {...rest}
      render={({ field: { ref, ...field }, fieldState: { error } }) => (
        <TextField
          {...field}
          type={type}
          label={label}
          size="small"
          fullWidth
          inputRef={ref}
          error={!!error}
          helperText={error?.message}
          slotProps={{
            formHelperText: { role: 'alert' },
            ...slotProps,
          }}
          onChange={(e) => {
            if (trim) field.onChange(e.target.value.trim());
            else if (number) field.onChange(e.target.value.replace(/[^\d]/g, ''));
            else field.onChange(e.target.value);
          }}
        />
      )}
    />
  );
};
